import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class ObjectivesRest {
  baseURL = "/graphs";

  getObjectiveById(chapterId: string, objectiveId: string): Observable<any> {
    const url: string = `/chapters/${chapterId}/learning-objectives/${objectiveId}`;
    return api.get(url, {}, this.baseURL);
  }

  getObjectives(chapterId: string, params?: QueryParams): Observable<any> {
    const url: string = `/chapters/${chapterId}/learning-objectives`;
    return api.get(url, params, this.baseURL);
  }

  getAllObjectivesByCourse(
    params: Omit<QueryParams, "page" | "size">
  ): Observable<any> {
    const url: string = `/learning-objectives/all`;
    return api.get(url, params, this.baseURL);
  }

  postObjective(chapterId: string, data: any): Observable<any> {
    const url: string = `/chapters/${chapterId}/learning-objectives`;
    return api.post(url, data, {}, this.baseURL);
  }

  postObjectiveTraditional(
    courseId: string,
    chapterId: string,
    data: any
  ): Observable<any> {
    const url: string = `/third-party/courses/${courseId}/chapter/${chapterId}/trail`;
    return api.post(url, data, {}, this.baseURL);
  }

  updateObjective(
    chapterId: string,
    objectiveId: string,
    data: any
  ): Observable<any> {
    const url: string = `/chapters/${chapterId}/learning-objectives/${objectiveId}`;
    return api.put(url, data, {}, this.baseURL);
  }

  nextObjective(
    courseId: string,
    userId: string,
    data: any,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `course-state/${courseId}/${userId}/add-learning-objective-event`;
    return api.post(url, data, params, "/graphs");
  }
}
